import api from '..';
export type Payload = {
  venda_id: number;
};

export const requestAnalysis = async (payload: Payload) => {
  const { data } = await api.get(
    `/core/elegibilidade/analise/${payload.venda_id}`,
  );

  return data;
};
